// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__wdceO"};